<template>
    <div class="related-product">
        <van-collapse v-if="list.length" v-model="activeNames" :border="false">
            <van-collapse-item
                v-for="item in list"
                :key="item.id"
                :title="item.detail.name"
                :name="item.id"
                :border="false"
            >
                <template #right-icon>
                    <img
                        class="list-icon"
                        :src="
                            activeNames.includes(item.id)
                                ? 'https://oss.cloud.custouch.com/res/217139/icon-close@3x.png'
                                : 'https://oss.cloud.custouch.com/res/217140/icon-open@3x.png'
                        "
                        alt=""
                    />
                </template>
                <div>
                    <div>
                        {{ item.detail.desc }}
                    </div>
                    <div v-if="item.detail.link" class="more" @click="$emit('go',item)">
                        点击查看产品详情
                    </div>
                </div>
            </van-collapse-item>
        </van-collapse>
    </div>
</template>
<script>
import { sleep } from '@custouch/proxy-use'
export default {
    props: ['list'],
    data() {
        return {
            activeNames: []
        }
    }
}
</script>
<style lang="less">
.related-product {
    .van-collapse-item {
        box-shadow: 0 0.05rem 0.2rem 0 #004da029;
        border-radius: @border-radius-sm + @border-radius-md;
        .van-collapse-item__title {
            &.van-collapse-item__title--expanded {
                border-radius: @border-radius-sm + @border-radius-md
                    @border-radius-sm + @border-radius-md 0 0;
                box-shadow: none;
            }
        }
        .van-collapse-item__wrapper {
            border-radius: 0 0 @border-radius-sm + @border-radius-md
                @border-radius-sm + @border-radius-md;
            background: @white;
            .van-collapse-item__content {
                margin: 0 @padding-md;
                padding: @padding-md 0;
                border-top: 1px solid #ebebeb;
                color: #333333;
                line-height: @line-height-md;
                .more {
                    margin-top: @padding-sm;
                    font-size: @font-size-sm;
                    line-height: @line-height-sm;
                    text-align: right;
                    color: #00a6eb;
                }
            }
        }
    }
}
</style>
